import { render, staticRenderFns } from "./CampaignSummarySettingsIntegrationItem.vue?vue&type=template&id=eababce6&scoped=true&"
import script from "./CampaignSummarySettingsIntegrationItem.vue?vue&type=script&lang=js&"
export * from "./CampaignSummarySettingsIntegrationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eababce6",
  null
  
)

export default component.exports